import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentsModule } from '@epicuro-next/platform/dynamic-components';
import { DynamicLogicalOperationsModule } from '@epicuro-next/platform/dynamic-logical-operations';
import { LetDirective } from '@ngrx/component';
import { DynamicElementsPopoverWrapperComponent } from './components/popover-wrapper/popover-wrapper.component';
import { DropdownModule } from '@epicuro-next/ataraxia/dropdown';
import { DynamicElementsDropdownWrapperComponent } from './components/dropdown-wrapper/dropdown-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    DynamicComponentsModule,
    DynamicLogicalOperationsModule,
    LetDirective,
    PopoverModule,
    DropdownModule,
  ],
  declarations: [
    DynamicElementsPopoverWrapperComponent,
    DynamicElementsDropdownWrapperComponent,
  ],
})
export class DynamicElementsPopoverModule {}

DontTreeShake(DynamicElementsPopoverWrapperComponent);
DontTreeShake(DynamicElementsDropdownWrapperComponent);
